import { useEffect } from 'react';
import { AppRoutes } from './AppRoutes';
try {
  navigator.serviceWorker.register(`${window.location.origin}/service-worker.js`).then(async (serviceWorker) => {
    try {
      let subscription = await serviceWorker.pushManager.getSubscription()
      if (!subscription) {
        subscription = await serviceWorker.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: process.env.REACT_APP_NOTIFICATION_KEY
        })
      }
      localStorage.setItem(window.btoa('subscription_notification'), window.btoa(JSON.stringify(subscription)))
    } catch (subscriptionError) {
      console.log('Erro ao subscrever notificações push:', subscriptionError)
    }
  }).catch((e) => {
    console.log('Erro ao registrar service worker:', e)
  })
  Notification.requestPermission(function (result) {
    if (result !== 'granted') {
      console.log('Permissões para notificações não foram garantidas')
    }
  }).catch((e) => {
    console.log('Erro ao solicitar permissão de notificações:', e)
  })
} catch (e) {
  console.log('Erro geral no service worker:', e)
}

window.addEventListener('beforeinstallprompt', function(e) {
  e.preventDefault();
  return false;
});


function App() {

  function installScrip() {
    try {
      if (process.env.REACT_APP_PROD === '1') {
        const scriptTag = document.createElement('script');
        scriptTag.innerHTML = `
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:4973708,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
        document.head.appendChild(scriptTag);
      }
    } catch (error) {
      console.log(error)
    }
}


useEffect(() => {
  installScrip()
}, [])


  return (
    <AppRoutes />
  );
}

export default App;
